import { RegisterClass } from "core/Misc/typeStore";
import { RewardGraphNode } from "../rewardGraphNode";
import { RewardGraphConnectionPointTypes } from "../rewardGraphConnectionPointTypes";
import { RewardGraphConnectionPoint } from "../rewardGraphConnectionPoint";

export class RewardLogicalNotBlock extends RewardGraphNode {
    /**
     * Create a new ConditionBlock
     * @param name defines the block name
     */
    public constructor(name: string) {
        super(name);

        this.registerInput("input", RewardGraphConnectionPointTypes.Boolean);
        this.registerOutput("output", RewardGraphConnectionPointTypes.Boolean);
    }

    /**
     * Gets the current class name
     * @returns the class name
     */
    public override getClassName() {
        return "RewardLogicalNotBlock";
    }

    /**
     * Gets the left input component
     */
    public get input(): RewardGraphConnectionPoint {
        return this._inputs[0];
    }

    /**
     * Gets the output component
     */
    public get output(): RewardGraphConnectionPoint {
        return this._outputs[0];
    }

    protected override _buildBlock() {
        if (!this.input.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }

        this.output._storedFunction = (state) => {
            return !this.input.getConnectedValue(state);
        };
    }
}

RegisterClass("MELS.RewardLogicalNotBlock", RewardLogicalNotBlock);
